exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-345f3852]{background-color:#fbfbfb}.setting-body[data-v-345f3852]{background-color:#fdfdfd}.gravatar-pic[data-v-345f3852]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}.rg-pic-wrapper .rg-pic-uploader-wrapper[data-v-345f3852]{display:none}.rg-pic-wrapper:hover .rg-pic-uploader-wrapper[data-v-345f3852]{display:block}", ""]);

// exports
